import { render } from "./current-status.vue?vue&type=template&id=95f497e6"
import script from "./current-status.vue?vue&type=script&lang=js"
export * from "./current-status.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__